/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreatedBy/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function CreatedBy({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/TxPlanNotes/Content/Content/All/Content/Notes/Content/Note/Author/CreatedBy"
  
}) {
let txPlanNoteCreatedByPersonValueData = fromData.useDataFormat({ viewPath,
context: 'tx_plan_note',
path: 'created_by.person',
format: fromFormat.personName,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="tx_plan_note.created_by.person"
 format="/Data/format.js personName"
 text={txPlanNoteCreatedByPersonValueData}
 color={dtColorsNeutral500}
 marginLeft={dtSpaceXxs}
 weight="bold"
/>
{children}
</React.Fragment>)
}